import { render, staticRenderFns } from "./SavedQueryList.vue?vue&type=template&id=f475b9ea&"
import script from "./SavedQueryList.vue?vue&type=script&lang=js&"
export * from "./SavedQueryList.vue?vue&type=script&lang=js&"
import style0 from "./SavedQueryList.vue?vue&type=style&index=0&id=f475b9ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports